import '@adornis/authentication/saml-client/api/resolver.js';
import '@adornis/filter/db/subscribePaginatedAndFiltered.js';
import './admin-users.js';
import './admin-mail.js';
import './admin.js';
import './booking.js';
import './calendar-feed.js';
import './company-registration.js';
import './company.js';
import './extractCvInformation.js';
import './job-application.js';
import './job-position.js';
import './mails.js';
import './matching-score.js';
import './statistics.js';
import './user.js';
import './admin-guard.js';
import './llm.js';
import './settings.js';
import '@adornis/bh-debug/api/index.js';
import '@adornis/bh-plugin-impl/api/index.js';
import '@adornis/buchungsheld-db/api/index.js';
import '@adornis/versioned-entity/api/index.js';
import './resume-file.js';
import './resume-review-file.js';
import './category.js';
